import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { makeStyles } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

const useStyles = makeStyles({
  message: {
    fontSize: '12px',
  },
  root: {
    paddingBottom: '5px',
    paddingTop: '10px',
  },
});

export const ImpressionThresholdMessage = () => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const message = i18n.getString(_TL_('Lift measurement might not have significant/useful results if audiences associated with your selected campaign(s) have less than one million impressions when the experiment is running. Results are also not guaranteed to be significant even if the impression threshold is met.'));

  return (
    <MessageBar className={styles.root}>
      <MessageBarBody>
        <span className={styles.message}>{message}</span>
      </MessageBarBody>
    </MessageBar>
  );
};
